export default __webpack_public_path__ + "static/media/slide_two.13a6beb9.jpg";